import React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import styles from './index.less';
import CookieSettingModalStore from '@src/components/cookie-modal/cookie-setting-modal/store';
import getPageLocalesData from '@src/global-locales/get-page-locales-data';

const pageLocalesData = getPageLocalesData();
const cookieInfo = pageLocalesData.cookieInfo;
/**
 * CookieSettingModal
 * @param store {CookieSettingModalStore}
 * @param onClose
 * @returns {JSX.Element}
 * @constructor
 */
const CookieSettingModal = ({ store, onClose }) => {
  store.use();

  /**
   * 渲染内容
   * @returns {JSX.Element}
   */
  const renderContainer = () => {
    const renderNecessaryCookieList = () => {
      return store.necessaryCookiesList.map((item, key) => {
        return (
          <div className={styles.cookieListItem} key={key}>
            <div className={styles.cookieListItemLabel}>
              {cookieInfo.label_name}: {item.name}
            </div>
            <div className={styles.cookieListItemLabel}>
              {cookieInfo.label_provider}: {item.provider}
            </div>
            <div className={styles.cookieListItemLabel}>
              {cookieInfo.label_duration}: {item.duration}
            </div>
            <div className={styles.cookieListItemLabel}>
              {cookieInfo.label_description}: <span className={styles.cookieListItemValue}>{item.description}</span>
            </div>
          </div>
        );
      });
    };
    const renderAnalyticsCookieList = () => {
      return store.analyseCookiesList.map((item, key) => {
        return (
          <div className={styles.cookieListItem} key={key}>
            <div className={styles.cookieListItemLabel}>
              {cookieInfo.label_name}: {item.name}
            </div>
            <div className={styles.cookieListItemLabel}>
              {cookieInfo.label_provider}: {item.provider}
            </div>
            <div className={styles.cookieListItemLabel}>
              {cookieInfo.label_duration}: {item.duration}
            </div>
            <div className={styles.cookieListItemLabel}>
              {cookieInfo.label_description}: <span className={styles.cookieListItemValue}>{item.description}</span>
            </div>
          </div>
        );
      });
    };
    if (store.showType === 0) {
      return (
        <div className={styles.box}>
          <div className={styles.cookieSettingsDesc}>{cookieInfo.settings_description}</div>
          <div className={styles.cookieList}>
            <div className={styles.cookieItem}>
              <div className={styles.cookieName}>{cookieInfo.necessary_cookies}</div>
              <div className={styles.viewDetails} onClick={() => store.redirectToPage(1)}>
                {cookieInfo.view_details}
              </div>
              <div className={styles.cookieDesc}>{cookieInfo.necessary_cookies_description}</div>
              <div className={cx(styles.switchIcon, styles.lockedStatus)} />
            </div>
            <div className={styles.cookieItem}>
              <div className={styles.cookieName}>{cookieInfo.analytics_cookies}</div>
              <div className={styles.viewDetails} onClick={() => store.redirectToPage(2)}>
                {cookieInfo.view_details}
              </div>
              <div className={styles.cookieDesc}>{cookieInfo.analytics_cookies_description}</div>
              <div
                className={cx(styles.switchIcon, store.acceptCookies.analytics && styles.openStatus)}
                onClick={() => store.onChangeAcceptCookieStatus('analytics')}
              />
            </div>
          </div>
        </div>
      );
    } else if (store.showType === 1) {
      return (
        <div className={styles.box}>
          <div className={styles.cookieListContainer} key={store.showType}>
            {renderNecessaryCookieList()}
          </div>
        </div>
      );
    } else if (store.showType === 2) {
      return (
        <div className={styles.box}>
          <div className={styles.cookieListContainer} key={store.showType}>
            {renderAnalyticsCookieList()}
          </div>
        </div>
      );
    } else {
      return null;
    }
  };
  /**
   * 渲染title
   * @returns {JSX.Element}
   */
  const renderTitle = () => {
    if (store.showType === 0) {
      return <div className={styles.title}>{cookieInfo.perference_settings}</div>;
    } else if (store.showType === 1) {
      return (
        <div className={styles.title}>
          <span className={styles.backToIndexIcon} onClick={store.backToIndex} />
          <span>{cookieInfo.necessary_cookies}</span>
        </div>
      );
    } else if (store.showType === 2) {
      return (
        <div className={styles.title}>
          <span className={styles.backToIndexIcon} onClick={store.backToIndex} />
          <span>{cookieInfo.analytics_cookies}</span>
        </div>
      );
    }
  };
  /**
   * 渲染按钮组
   * @returns {JSX.Element}
   */
  const renderBtnGroup = () => {
    return (
      <div className={styles.btnGroup}>
        <div className={cx(styles.theBtnOfGroup)} onClick={store.onConfirmCookieOptionsClick}>
          {cookieInfo.confirm_btn}
        </div>
        <div className={cx(styles.theBtnOfGroup)} onClick={store.acceptOptionalCookies}>
          {cookieInfo.allow_all_btn}
        </div>
      </div>
    );
  };
  return (
    <div className={cx(styles.root)}>
      <div className={styles.container}>
        <div className={styles.closeBtn} onClick={onClose} />
        {renderTitle()}
        {renderContainer()}
        {renderBtnGroup()}
      </div>
    </div>
  );
};

export default wrapStore(CookieSettingModal, CookieSettingModalStore);
